'use client'

import { ButtonText } from '@/components/common/Button'
import { FiltersPanel } from '@/components/common/FiltersPanel'
import { MenuTitle } from '@/components/common/MenuTitle'
import { Icon } from '@/components/icons/Icon'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'

import { MenuCommonRoot } from '../MenuCommon/MenuCommonRoot/MenuCommonRoot'

export const MenuFilters = () => {
  const dispatch = useReduxDispatch()
  const isOpen = useReduxSelector((s) => s.view.mobileStatus === 'filters')

  return (
    <MenuCommonRoot isOpen={isOpen} variant='filters'>
      {isOpen && (
        <>
          <MenuTitle>
            <h2>Filters</h2>
            <ButtonText
              aria-label='Close'
              colorScheme='light'
              hover='warning'
              onClick={() => dispatch(viewActions.toggleMobileStatus('closed'))}
              size='lg'
            >
              <Icon name='xMark' />
            </ButtonText>
          </MenuTitle>
          <FiltersPanel />
        </>
      )}
    </MenuCommonRoot>
  )
}
